import React from 'react';
import LoginPage from '../Pages/LoginPage';
import ConfirmEmailPage from '../Pages/ConfirmEmailPage';
import ConfirmJointHolderPage from '../Pages/ConfirmJointHolderPage';
import IpoApplicationPage from '../Pages/IpoApplicationPage';
import RegisterPage from '../Pages/RegisterPage';
import AppRoute, { LayoutType } from './models/AppRoute';
import {
    AdminLayout,
    ClassicLayout,
    LoginLayout,
    LandingLayout,
    ResetLayout,
    RegisterLayout,
} from '../components/Layout';
import LogoutPage from 'Pages/LogoutPage';
import { Operations } from './Api/Api';
import NotFoundView from 'components/Error/NotFoundView';
import EmptyLayout from 'components/Layout/EmptyLayout';
import JcsdAccountListPage from 'Pages/JcsdAccountListPage';
import IpoListPage from 'Pages/IpoListPage';
//import IpoDetailsPage from 'Pages/IpoDetailsPage';
import JcsdAccountDetailPage from 'Pages/JcsdAccountDetailPage';
import JcsdAccountWizardPage from 'Pages/JcsdAccountWizardPage';
import DashboardPage from 'Pages/DashboardPage';
import FAQPage from 'Pages/Information/FAQPage';
import OfferingDetailsViewPage from 'Pages/OfferingDetailsViewPage';
import OfferingListPage from 'Pages/OfferingListPage';
import CenteredLandingLayout from 'components/Layout/CenteredLandingLayout';
import ResetPasswordPage from 'Pages/UserProfile/ResetPasswordPage';
import RequestPasswordResetPage from 'Pages/RequestPasswordResetPage';
import UserProfilePage from '../Pages/UserProfile/UserProfilePage';
import EditUserProfilePage from '../Pages/UserProfile/EditUserProfilePage';
import ChangePasswordPage from '../Pages/UserProfile/ChangePasswordPage';
import UpdateSecurityQuestionPage from '../Pages/UserProfile/UpdateSecurityQuestionPage';
import IpoApplicationDetailsPage from 'Pages/IpoApplicationDetailsPage';
import OfferingApplicationListPage from 'Pages/OfferingApplicationListPage';
import OfferingApplicationDetailPage from 'Pages/OfferingApplicationDetailPage';
import ResendActivationPage from '../Pages/ResendActivationPage';

export const AppRoutes: AppRoute[] = [
    {
        title: 'Home',
        component: () => <h1> Home !</h1>,
        path: '/',
        redirect: 'welcome',
        icon: 'star',
        exact: true,
        skip: true,
        routes: [
            {
                title: 'Dashboard',
                hideInMainMenu: true,
                icon: 'area-chart',
                layout: (props: any) => <LandingLayout {...props} />,
                path: 'dashboard',
                component: DashboardPage,
            },
            {
                title: 'Dashboard',
                icon: 'area-chart',
                hideInMainMenu: true,

                layout: (props: any) => <LandingLayout {...props} />,
                path: 'welcome',
                component: DashboardPage,
            },
            {
                title: 'My Accounts',
                icon: 'wallet',
                layout: (props: any) => <LandingLayout {...props} />,
                requiredOperations: [Operations.Is_Authenticated],
                path: 'jcsd-accounts',
                component: JcsdAccountListPage,
            },
            {
                title: 'My Applications',
                icon: 'wallet',
                layout: (props: any) => <LandingLayout {...props} />,
                requiredOperations: [Operations.Is_Authenticated],
                path: 'applications',
                component: OfferingApplicationListPage,
            },
            {
                title: 'Application Details',
                path: 'applications/:name',
                icon: 'Users',
                layout: (props: any) => <LandingLayout {...props} />,
                requiredOperations: [Operations.Is_Authenticated],
                hideInMainMenu: true,
                exact: true,
                component: OfferingApplicationDetailPage,
            },
            {
                title: 'JCSD Account Details',
                path: 'jcsd-accounts/:name',
                icon: 'Users',
                layout: (props: any) => <LandingLayout {...props} />,
                requiredOperations: [Operations.Is_Authenticated],
                hideInMainMenu: true,
                exact: true,
                component: JcsdAccountDetailPage,
            },
            {
                title: 'JCSD Account Wizard',
                path: 'accounts/wizard',
                layout: (props: any) => <LandingLayout {...props} />,
                icon: 'Users',
                requiredOperations: [Operations.Is_Authenticated],
                hideInMainMenu: true,
                exact: true,
                component: JcsdAccountWizardPage,
            },
            {
                title: 'Settings',
                icon: 'cog',
                hideInMainMenu: true,
                path: 'settings',
                component: () => <h1> settings </h1>,
                routes: [
                    {
                        title: 'Account',
                        hideInMainMenu: true,
                        icon: 'user',
                        layout: (props: any) => <LandingLayout {...props} />,
                        path: 'settings/account',
                        component: () => <h1> Account </h1>,
                    },
                ],
            },
            {
                title: 'Offering',
                path: '/ipo/details/:id',
                icon: 'area-chart',
                hideInMainMenu: true,
                layout: (props: any) => <CenteredLandingLayout {...props} />,
                component: OfferingDetailsViewPage,
            },
            {
                title: 'Change Password',
                path: '/change-password',
                icon: 'folder',
                layout: (props: any) => <LandingLayout {...props} />,
                requiredOperations: [Operations.Is_Authenticated],
                hideInMainMenu: true,
                exact: true,
                component: ChangePasswordPage
            },
            {
                title: 'Update Security Questions',
                path: '/update-security',
                icon: 'folder',
                layout: (props: any) => <LandingLayout {...props} />,
                requiredOperations: [Operations.Is_Authenticated],
                hideInMainMenu: true,
                exact: true,
                component: UpdateSecurityQuestionPage
            },
            {
                title: 'User Profile',
                path: '/user-profile',
                icon: 'folder',
                layout: (props: any) => <LandingLayout {...props} />,
                requiredOperations: [Operations.Is_Authenticated],
                hideInMainMenu: true,
                exact: true,
                component: UserProfilePage
            },
            {
                title: 'Edit User Profile',
                path: '/edit-user-profile',
                icon: 'folder',
                layout: (props: any) => <LandingLayout {...props} />,
                requiredOperations: [Operations.Is_Authenticated],
                hideInMainMenu: true,
                exact: true,
                component: EditUserProfilePage
            },
        ],
    },
    {
        title: 'Logout',
        path: '/logout',
        icon: 'power',
        exact: true,
        hideInMainMenu: true,
        layout: (props: any) => <LoginLayout {...props} />,
        component: LogoutPage,
    },
    {
        title: 'Login',
        path: '/login',
        icon: 'up',
        exact: true,
        hideInMainMenu: true,
        layout: (props: any) => <LoginLayout {...props} />,
        component: LoginPage,
    },
    {
        title: 'FAQ',
        path: '/faq',
        hideInMainMenu: true,
        layout: (props: any) => <LandingLayout {...props} />,
        component: FAQPage,
    },
    //{
    //    title: 'View JCSD Accounts',
    //    path: '/view-jcsd-accounts',
    //    icon: 'up',
    //    exact: true,
    //    hideInMainMenu: false,
    //    layout: (props: any) => <ClassicLayout {...props} />,
    //    component: ConfirmEmailPage, /* JcsdAccountListPage,*/
    //},
    {
        title: 'Confirm Email',
        path: '/confirm-email',
        icon: 'up',
        exact: true,
        hideInMainMenu: true,
        layout: (props: any) => <LoginLayout {...props} />,
        component: ConfirmEmailPage,
    },

    {
        title: 'Confirm Joint Holders',
        path: '/ipo/confirm-joint-holder',
        icon: 'up',
        exact: true,
        hideInMainMenu: true,
        layout: (props: any) => <LoginLayout {...props} />,
        component: ConfirmJointHolderPage,
    },
    {
        title: 'Offerings',
        icon: 'fund',
        path: '/ipo',
        layout: (props: any) => <LandingLayout {...props} />,
        component: OfferingListPage,
        routes: [
            //{
            //    title: 'IPO',
            //    path: '/',
            //    icon: 'up',
            //    exact: true,
            //    hideInMainMenu: true,
            //    layout: (props: any) => <ClassicLayout {...props} />,
            //    component: OfferingListPage,
            //},
            //{
            //    title: 'IPO',
            //    path: '/details/:id',
            //    icon: 'up',
            //    exact: true,
            //    hideInMainMenu: true,
            //    layout: (props: any) => <ClassicLayout {...props} />,
            //    component: IpoDetailsPage,
            //},
            {
                title: 'Apply for IPO',
                path: 'apply/:id',
                icon: 'up',
                exact: true,
                requiredOperations: [Operations.Is_Authenticated],

                hideInMainMenu: true,
                layout: (props: any) => <CenteredLandingLayout {...props} />,
                component: IpoApplicationPage,
            },
        ],
    },

    {
        title: 'Terms',
        path: '/terms',
        exact: true,
        hideInMainMenu: true,
    },
    {
        title: 'Privacy',
        path: '/privacy',
        exact: true,
        hideInMainMenu: true,
    },
    {
        title: 'Register',
        path: '/register',
        icon: 'up',
        exact: true,
        hideInMainMenu: true,
        layout: (props: any) => <RegisterLayout {...props} />,
        component: RegisterPage,
    },
    {
        title: 'Reset Password',
        path: '/reset-password',
        hideInMainMenu: true,
        layout: (props: any) => <ResetLayout {...props} />,
        component: RequestPasswordResetPage,
    },
    {
        title: 'Resend Activation',
        path: '/resend-activation',
        hideInMainMenu: true,
        layout: (props: any) => <ResetLayout {...props} />,
        component: ResendActivationPage,
    },
    {
        title: 'Reset Password',
        path: '/reset-password-confirm',
        hideInMainMenu: true,
        layout: (props: any) => <ResetLayout {...props} />,
        component: ResetPasswordPage,
    },
    {
        title: '404',
        path: '/*',
        hideInMainMenu: true,
        layout: (props: any) => <EmptyLayout {...props} />,
        component: NotFoundView,
    },
];
